export default __webpack_public_path__ + "static/media/video.52535072.png";